"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubZeroSaltFish = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var ResourceType_1 = require("../../ResourceType");
var Resources_1 = require("../../Resources");
var DecreaseAnyProduction_1 = require("../../deferredActions/DecreaseAnyProduction");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
var Options_1 = require("../Options");
var SubZeroSaltFish = (function (_super) {
    __extends(SubZeroSaltFish, _super);
    function SubZeroSaltFish() {
        var _this = _super.call(this, {
            cost: 5,
            tags: [Tags_1.Tags.ANIMAL],
            name: CardName_1.CardName.SUBZERO_SALT_FISH,
            cardType: CardType_1.CardType.ACTIVE,
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(-6); }),
            metadata: {
                cardNumber: 'C42',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 Animal to this card.', function (eb) {
                        eb.empty().startAction.animals(1);
                    }).br;
                    b.production(function (pb) { return pb.minus().plants(1, { all: Options_1.all }); }).br;
                    b.vpText('1 VP per 2 Animals on this card.');
                }),
                description: {
                    text: 'Requires -6 C. Decrease any Plant production 1 step.',
                    align: 'left',
                },
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.animals(1, 2),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    SubZeroSaltFish.prototype.canAct = function () {
        return true;
    };
    SubZeroSaltFish.prototype.canPlay = function (player) {
        return player.game.someoneHasResourceProduction(Resources_1.Resources.PLANTS, 1);
    };
    SubZeroSaltFish.prototype.action = function (player) {
        player.addResourceTo(this);
        return undefined;
    };
    SubZeroSaltFish.prototype.play = function (player) {
        player.game.defer(new DecreaseAnyProduction_1.DecreaseAnyProduction(player, Resources_1.Resources.PLANTS, 1));
        return undefined;
    };
    SubZeroSaltFish.prototype.getVictoryPoints = function () {
        return Math.floor(this.resourceCount / 2);
    };
    return SubZeroSaltFish;
}(Card_1.Card));
exports.SubZeroSaltFish = SubZeroSaltFish;
